import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertBoxComponent {
  @Input()
  editorMessages;

  @Output()
  closeHandler: EventEmitter<void> = new EventEmitter<void>();

  public onCloseClick() {
    this.closeHandler.emit();
  }
}
